import { gql } from "apollo-angular";
import { DocumentNode } from "graphql";

const  GET_STORE_FUNCTIONALITY: DocumentNode = gql`

query StoreFunctionality($storeId: UUID!) {
    funcionalitiesByStoreId(storeId: $storeId) {
      functionalityCode
      functionalityName
    }
  }`

  export { GET_STORE_FUNCTIONALITY };